import clsx from 'clsx';
import { MarkdownWithBulletProps } from 'interfaces/cms/content';
import { useRouter } from 'next/router';
import Markdown from '../MarkdownV2';

export default function MarkdownWithBullet({
  bulletColor,
  subtitle,
  align,
  subtitleColor,
  cssClass = '',
}: MarkdownWithBulletProps) {
  const { locale } = useRouter();

  return (
    <div
      className={clsx(
        'heart-bullet',
        bulletColor ?? bulletColor,
        cssClass ?? cssClass,
        locale == 'th-TH' && 'checkmark'
      )}
    >
      <Markdown md={subtitle} textAlign={align} textColor={subtitleColor} />
    </div>
  );
}
